import moment from 'moment'
import { Days } from '@e3dc-react/shell/Libs/date/types'

export enum DynamicTariffSettingsFormFields {
  GridFeeState = 'gridFeeState',
  GridFees = 'gridFees',
  PowerPriceState = 'powerPriceState',
  PowerPrices = 'powerPrices',
  Taxes = 'taxes',
  VatPercent = 'vatPercent',
  SurchargePercent = 'surchargePercent',
  SurchargeValue = 'surchargeValue',
  SurchargeUnit = 'surchargeUnit',
}

/* decorative, frontend-only unit for the dynamic power price surcharge. never sent to the backend */
export enum SurchargeUnit {
  Percent = '%',
  CtPerKwh = 'ct/kWh',
}

/* can be used when we need to use a fixed leap year in date picker */
export const LeapYear = 1972
export const firstDayOfALeapYear = moment('1972-01-01')
export const lastDayOfALeapYear = moment('1972-12-31')
export const DayMonthDateFormat = 'DD.MM'
export const beginningOfDay = new Date(LeapYear, 0, 1, 0, 0, 0, 0)
export const endOfDay = new Date(LeapYear, 0, 1, 23, 59, 0, 0)
export const MinutesStep = 15

/* maximum number of manual power price periods that can be configured */
export const MAX_MANUAL_POWER_PRICE_PERIODS = 30

/* a fresh, empty weekday selection object for the WeekDaySelector */
export const createEmptyWeekdaySelection = (): Days => ({
  mo: false,
  tu: false,
  we: false,
  th: false,
  fr: false,
  sa: false,
  su: false,
})

export enum ManualPowerPriceTranslationKey {
  Weekdays = 'dynamic-tariff-settings.manual-power-price.weekdays',
  From = 'dynamic-tariff-settings.manual-power-price.from',
  Until = 'dynamic-tariff-settings.manual-power-price.until',
  Price = 'dynamic-tariff-settings.manual-power-price.price',
}

export enum VariableGridFeesTranslationKey {
  From = 'dynamic-tariff-settings.variable-grid-fees.from',
  Until = 'dynamic-tariff-settings.variable-grid-fees.until',
  Fees = 'dynamic-tariff-settings.variable-grid-fees.fees',
  Description = 'dynamic-tariff-settings.variable-grid-fees.description',
}
